import * as React from 'react'
import { getStepConfig } from '../../step-config'
import { getSubtitle } from './helpers'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import { useJourneyContext } from '../../context'
import { JourneyStep } from '../../types/journey-nodes'

export const JourneyNodeLabel = ({ node, loading }: { node: JourneyStep; loading?: boolean }) => {
    const [state] = useJourneyContext()

    return (
        <div className="label">
            {state.journey && (
                <>
                    <span className="header">{getStepConfig(node)?.nodeLabel}</span>
                    <span className="subtitle">
                        {loading ? <Loading3QuartersOutlined spin={true} /> : getSubtitle(node, state.journey)}
                    </span>
                </>
            )}
        </div>
    )
}
